import React, { useContext, Suspense, lazy } from 'react'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import AppLayout from 'views/Layout'
import { ConfigProvider } from 'antd'
import { StoreToken, User } from 'store/context'
import Loading from 'components/Loading'
import CurrentLanguage from 'utils/currentLanguage'
import pt_BR from 'antd/lib/locale/pt_BR'
import en_US from 'antd/lib/locale/en_US'
import Firebase from 'store/services/Firebase'
import Authentication from './Login/View'

const Logout = lazy(() => import(`./Logout`))
const ReportToken = lazy(() => import(`./Public/ReportToken`))

function RouteInterceptor({ children, isAuthenticated, isAutoTag, ...rest }) {
  const locale = {
    'pt-BR': pt_BR,
    'en-US': en_US,
  }
  return (
    <Route
      {...rest}
      render={() =>
        !isAuthenticated ? (
          <Redirect to={{ pathname: '/login' }} />
        ) : isAutoTag ? (
          <Redirect to={{ pathname: '/auto-tag-success' }} />
        ) : (
          <Firebase>
            <ConfigProvider locale={locale[CurrentLanguage.get()]}>{children}</ConfigProvider>
          </Firebase>
        )
      }
    />
  )
}

function LoginCheck({ children, isAuthenticated, isAutoTag, ...rest }) {
  return (
    <Route
      {...rest}
      render={() =>
        !isAuthenticated ? children : <Redirect to={{ pathname: isAutoTag ? '/auto-tag-success' : '/' }} />
      }
    />
  )
}

export const Views = () => {
  const { token } = useContext(StoreToken)
  const { user } = useContext(User)
  const isAdmin = user?.context === 'root'
  const isAutoTag = Boolean(user?.is_auto_tag && !isAdmin)
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route exact path={'/report/:farm/token/:token'}>
          <ReportToken />
        </Route>
        <Route component={Logout} path={`/logout`} name={'logout'} exact />
        {/* Login page */}
        <LoginCheck exact path={'/login'} isAuthenticated={token} isAutoTag={isAutoTag}>
          <Authentication type={'login'} />
        </LoginCheck>
        {/* Forgot Password page */}
        <Route exact path={'/forgot'}>
          <Authentication type={'forgot'} />
        </Route>
        {/* Register New Password page */}
        <Route exact path={'/reset'}>
          <Authentication type={'reset'} />
        </Route>
        <Route exact path={'/auto-tag-success'}>
          <Authentication type={'autoTagSuccess'} />
        </Route>
        {/* Interceptor FARM context */}
        <RouteInterceptor path={'/farm'} isAuthenticated={token} isAutoTag={isAutoTag}>
          <AppLayout />
        </RouteInterceptor>
        {/* Interceptor ROOT context */}
        <RouteInterceptor path={'/'} isAuthenticated={token} isAutoTag={isAutoTag}>
          <AppLayout />
        </RouteInterceptor>
      </Switch>
    </Suspense>
  )
}

export default withRouter(Views)
